import { CityIcon } from '@synoptic/ui-kit/icons/react/city.js';
import { paths } from '@/routes-utils/paths.ts';
import { useAuthInfo } from '../../../use-auth-info.ts';
import { MenuActionLink } from './menu-action-link.tsx';
import { RequestAccessMenuModal } from './request-access-menu-modal.tsx';

export type EnterpriseMenuActionProps = {
  className?: string;
};

export const EnterpriseMenuAction = function EnterpriseMenuAction({
  className,
}: EnterpriseMenuActionProps) {
  const { isEnterprise } = useAuthInfo();

  if (isEnterprise) {
    return (
      <MenuActionLink
        icon={<CityIcon />}
        to={paths.enterprise}
        label="Enterprise"
        className={className}
      />
    );
  }

  return (
    <RequestAccessMenuModal
      label="Enterprise"
      modalDescriptionContent="Get in touch to learn more about our enterprise solutions."
      icon={<CityIcon />}
      className={className}
    />
  );
};
